import React, { useEffect, useState } from "react"
import { cookieOptanononSettingConfig } from "../utils/footerUtils"
import { replaceImageStyle, isBrowser } from "../utils/common"
import * as cheerio from "cheerio"

const DESKTOP_CLASSES =
  ".wu-footer--landing-page__top__col--lg__title,.wu-footer--landing-page__top__col--lg__link,.wu-footer--landing-page__bm__col__bm__logo > .d-none,.wu-footer--landing-page__bm__col__mid--lg,.wu-footer--landing-page__bm__col__mid--lg__copyrights"
const MOBILE_CLASSES =
  ".wu-footer--landing-page__top__col__sm-accordion,wu-footer--landing-page__bm__col__bm__logo > .d-L-none,.wu-footer--landing-page__bm__col__mid--sm,.wu-footer--landing-page__bm__col__mid--sm__copyrights"

export default function FooterComponent({ 
  content 
}) {
  const [isMobile, setMobile] = useState(false)

  isBrowser() && window.addEventListener("resize", () => {
      if (
        window.innerWidth > 1200
      ) {
        setMobile(false)
      } else {
        setMobile(true)
      }
    })

  useEffect(() => {
    cookieOptanononSettingConfig()
    if (
      isBrowser() && 
      window.innerWidth > 1200
    ) {
      setMobile(false)
    } else {
      setMobile(true)
    }
  }, [])

  useEffect(() => {
    window.loadIcons && window.loadIcons()
    window.statFlag && window.statFlag()
  }, [content, isMobile])

  const handleContent = () => {
    if (
      content
    ) {
      const $ = cheerio.load(content)
      let classNameRemove = isMobile ? DESKTOP_CLASSES : MOBILE_CLASSES
      $(`${classNameRemove}`).remove()
      return replaceImageStyle($.html())
    }
  }

  return (
    <div
      className="entry-content"
      dangerouslySetInnerHTML={{ __html: handleContent() }}
    ></div>
  )
}
